// @ts-nocheck
/**
 * Payload de favoritos alinhado ao Firestore (users/{uid}/favorites/{profileId}.radios[]).
 * Usado pelo radios.pro antes de localStorage e POST /ajax/ajax-favorites.php.
 */
(function (global) {
    'use strict';

    var LOGO_BASE = 'https://appradio.pro/uploads/radio_logos/';

    function trim(value) {
        return String(value == null ? '' : value).trim();
    }

    function joinPublicUrl(base, path) {
        var b = trim(base).replace(/\/+$/, '');
        var p = trim(path).replace(/^\/+/, '');
        if (!p) return b || '/';
        if (!b) return '/' + p;
        if (/^https?:\/\//i.test(b)) return b + '/' + p;
        if (b.charAt(0) === '/') return b + '/' + p;
        return '/' + b + '/' + p;
    }

    function fixBrokenRadiosProUrl(url) {
        var s = trim(url);
        if (!s) return s;
        return s.replace(/^(https?:\/\/)radios\.proassets\//i, '$1radios.pro/assets/');
    }

    function defaultSiteLogoUrl() {
        var base = trim(
            global.APPRADIO_PUBLIC_BASE ||
            global.RPRO_PUBLIC_BASE ||
            (global.MY_RADIOS_CONFIG && global.MY_RADIOS_CONFIG.baseUrl) ||
            ''
        );
        return joinPublicUrl(base, 'assets/img/header/logo.png');
    }

    function firstStreamUrl(source) {
        if (!source || typeof source !== 'object') return '';
        var direct = trim(
            source.url_stream_audio ||
            source.url_stream_audio_secondary ||
            source.streaming_url ||
            source.streamingUrl ||
            source.stream_url ||
            source.streamUrl
        );
        if (direct) return direct;
        if (Array.isArray(source.streams)) {
            for (var i = 0; i < source.streams.length; i += 1) {
                var url = trim(source.streams[i] && source.streams[i].url);
                if (url) return url;
            }
        }
        return '';
    }

    function favoriteLogoToStorage(logoUrl) {
        // Armazena a URL completa para evitar 404s ao reconstruir.
        // Versão anterior extraía só o basename, o que causava URLs erradas
        // para logos de CDN externo (TopContents, etc.).
        return trim(logoUrl);
    }

    function favoriteLogoToUrl(logo) {
        var s = fixBrokenRadiosProUrl(trim(logo));
        if (!s) return '';
        if (/^https?:\/\//i.test(s)) return s;
        if (s.indexOf('/') === -1) {
            return LOGO_BASE + encodeURIComponent(s);
        }
        if (s.charAt(0) === '/') {
            return 'https://appradio.pro' + s;
        }
        return 'https://appradio.pro/' + s;
    }

    function buildFavoriteRadioPayload(source) {
        source = source || {};
        var id = parseInt(source.id || source.radioId, 10);
        if (!id || isNaN(id)) return null;

        var name = trim(
            source.name ||
            source.title ||
            source.radio_name ||
            source.radioName ||
            source.nome
        ) || 'Rádio';

        var logoRaw = fixBrokenRadiosProUrl(trim(
            source.logo ||
            source.url_logo ||
            source.logo_url ||
            source.logoUrl ||
            source.urlLogo
        ));
        var stream = firstStreamUrl(source);
        var streamSecondary = trim(source.url_stream_audio_secondary) || stream;
        var location = trim(source.localizacao || source.location);
        var segment = trim(source.segmento || source.segment || source.category);
        var logoDisplay = favoriteLogoToUrl(logoRaw) || logoRaw;

        return {
            id: id,
            type: 'radio',
            name: name,
            logo: favoriteLogoToStorage(logoRaw),
            description: trim(source.description),
            url_stream_audio: stream,
            url_stream_audio_secondary: streamSecondary,
            url_stream_video: trim(source.url_stream_video),
            catalogKey: trim(source.catalogKey),
            catalogIndex: parseInt(source.catalogIndex, 10) || 0,
            playedAt: parseInt(source.playedAt, 10) || Date.now(),
            title: name,
            radio_name: name,
            url_logo: logoDisplay,
            logo_url: logoDisplay,
            localizacao: location,
            location: location,
            segmento: segment,
            category: segment,
            streaming_url: stream,
            stream_url: stream,
            streams: stream ? [{ url: stream }] : (Array.isArray(source.streams) ? source.streams : [])
        };
    }

    global.RadiosProFavorites = {
        buildPayload: buildFavoriteRadioPayload,
        logoToStorage: favoriteLogoToStorage,
        logoToUrl: favoriteLogoToUrl,
        firstStreamUrl: firstStreamUrl,
        joinPublicUrl: joinPublicUrl,
        defaultSiteLogoUrl: defaultSiteLogoUrl,
        fixBrokenRadiosProUrl: fixBrokenRadiosProUrl
    };
}(typeof window !== 'undefined' ? window : globalThis));

export function initFavoriteRadioPayload() {
    return (typeof window !== 'undefined') ? window.RadiosProFavorites : null;
}
